export const GO_TO_LEVEL = 'GO_TO_LEVEL';
export const NEXT_LEVEL = 'NEXT_LEVEL';
export const PREV_LEVEL = 'PREV_LEVEL';
export const TOGGLE_VISIBILITY = 'TOGGLE_VISIBILITY';
export const SET_HTML = 'SET_HTML';
export const ANCHOR_TO = 'ANCHOR_TO';
export const TOGGLE_SELF_CONTAINED_MODE = 'TOGGLE_SELF_CONTAINED_MODE';
export const REPLACE_PALETTE = 'REPLACE_PALETTE';
